import React, {useState, useMemo} from 'react'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

const {I18n} = window

interface NonEventDayInstructorDetailProps {
  eventId: number
  instructorId: number
  minDate?: string
  maxDate?: string
  existingNonEventDays?: string[]
  onAddNonEventDay?: (date: string) => void
  inputName: string
}

const NonEventDayInstructorDetail: React.FC<NonEventDayInstructorDetailProps> = ({
                                                                                   eventId,
                                                                                   instructorId,
                                                                                   minDate,
                                                                                   maxDate,
                                                                                   existingNonEventDays = [],
                                                                                   onAddNonEventDay,
                                                                                   inputName
                                                                                 }) => {
  const [selectedDate, setSelectedDate] = useState<string | null>(null)

  const pickerOptions = useMemo(() => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const eventStart = minDate ? new Date(minDate) : null
    if (eventStart) eventStart.setHours(0, 0, 0, 0)

    const eventEnd = maxDate ? new Date(maxDate) : null
    if (eventEnd) eventEnd.setHours(0, 0, 0, 0)

    // eventEnd + 15 days
    var fifteenDaysAfterEvent: Date | null = null
    if (eventEnd) {
      fifteenDaysAfterEvent = new Date(eventEnd)
      fifteenDaysAfterEvent.setDate(fifteenDaysAfterEvent.getDate() + 15)
      fifteenDaysAfterEvent.setHours(0, 0, 0, 0)
    }

    // last allowed = earlier of today and (eventEnd + 15 days), or today if no eventEnd
    var lastAllowed = today
    if (fifteenDaysAfterEvent && fifteenDaysAfterEvent < today) {
      lastAllowed = fifteenDaysAfterEvent
    }

    const disabledExistingTimestamps = existingNonEventDays.map(function (d) {
      const dt = new Date(d + 'T00:00')
      return dt.getTime()
    })

    // Main disable rule: return true to disable a date
    const disableFn = function (date: Date) {
      const d = new Date(date)
      d.setHours(0, 0, 0, 0)
      const t = d.getTime()

      if (eventStart && d < eventStart) return true
      if (d > lastAllowed) return true
      if (disabledExistingTimestamps.indexOf(t) !== -1) return true

      return false
    }

    return {
      dateFormat: 'Y-m-d',
      disable: [disableFn],
    }
  }, [minDate, maxDate, existingNonEventDays])

  // Flatpickr -> "YYYY-MM-DD"
  const handleDateChange = (dates: Date[]): void => {
    const first = dates && dates[0] ? dates[0] : null
    if (first) {
      const year = first.getFullYear()
      const month = ('0' + (first.getMonth() + 1)).slice(-2)
      const day = ('0' + first.getDate()).slice(-2)
      const formatted = year + '-' + month + '-' + day
      setSelectedDate(formatted)
    } else {
      setSelectedDate(null)
    }
  }

  const isAddDisabled = !selectedDate

  return (
    <div className="form-row align-items-end">
      <div className="col-lg-4 col-sm-12">
        <input type="hidden" name={inputName} value={selectedDate}/>
        <Flatpickr
          value={selectedDate}
          onChange={handleDateChange}
          options={pickerOptions}
          placeholder={I18n.t('views.events.select_date')}
          className="form-control bg-white flatpickr-input"
        />
      </div>

      <div className="col-auto">
        <input
          type="submit"
          name="commit"
          value={I18n.t('views.events.add_non_event_day')}
          disabled={isAddDisabled}
          className="mdi mdi-plus-thick pr-1 btn btn-sm btn-primary rounded py-2"
        />
      </div>
    </div>
  )
}

export default NonEventDayInstructorDetail
